module.exports = __webpack_public_path__ + "img/31e725d.png";